export class RubricPosition {
    fileName: string;
}
